<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="admin-layout">
    <!-- 後台側邊欄 -->
    <aside class="admin-sidebar">
      <div class="sidebar-logo">
        <img
          src="@/assets/logo.png"
          alt="綠憩植研 Logo"
          class="sidebar-logo-icon"
        />
        <div>
          <div class="sidebar-logo-zh">綠憩植研</div>
          <div class="sidebar-logo-sub">管理後台</div>
        </div>
      </div>

      <nav class="sidebar-nav">
        <router-link to="/admin/products" class="sidebar-link">
          <span class="sidebar-icon">🪴</span>
          <span>商品管理</span>
        </router-link>
        <router-link to="/admin/services" class="sidebar-link">
          <span class="sidebar-icon">🌱</span>
          <span>服務管理</span>
        </router-link>
        <router-link to="/admin/news" class="sidebar-link">
          <span class="sidebar-icon">📰</span>
          <span>最新消息</span>
        </router-link>
        <router-link to="/admin/contacts" class="sidebar-link">
          <span class="sidebar-icon">✉️</span>
          <span>聯絡表單</span>
        </router-link>
      </nav>

      <div class="sidebar-footer">
        <div class="sidebar-user">
          <span class="sidebar-user-icon">👤</span>
          <span>{{ displayName }}</span>
        </div>
        <button @click="logout" class="btn-logout">登出</button>
        <router-link to="/" class="btn-front">回前台</router-link>
      </div>
    </aside>

    <!-- 後台主內容 -->
    <main class="admin-main">
      <router-view />
    </main>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useRouter } from "vue-router";
import axios from "axios";

const router = useRouter();
const displayName = computed(
  () => localStorage.getItem("displayName") || "管理員"
);

const logout = () => {
  localStorage.removeItem("jwtToken");
  localStorage.removeItem("displayName");
  delete axios.defaults.headers.common["Authorization"];
  router.push("/login");
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.admin-layout {
  display: flex;
  min-height: 100vh;
  font-family: "Noto Sans TC", "Microsoft JhengHei", sans-serif;
  background: #f5f7fa;
}

.admin-sidebar {
  width: 240px;
  background: #1c2b1a;
  color: white;
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  z-index: 100;
}

.sidebar-logo {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 24px 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.sidebar-logo-icon {
  width: 32px;
  height: 32px;
  object-fit: contain;
  border-radius: 6px;
  flex-shrink: 0;
}

.sidebar-logo-zh {
  font-size: 16px;
  font-weight: 600;
}

.sidebar-logo-sub {
  font-size: 11px;
  opacity: 0.6;
  margin-top: 2px;
}

.sidebar-nav {
  flex: 1;
  padding: 20px 12px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.sidebar-link {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border-radius: 8px;
  text-decoration: none;
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
  transition: all 0.3s;
}

.sidebar-link:hover {
  background: rgba(255, 255, 255, 0.1);
  color: white;
}

.sidebar-link.router-link-active {
  background: #4e7b4f;
  color: white;
}

.sidebar-icon {
  font-size: 18px;
}

.sidebar-footer {
  padding: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.sidebar-user {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  padding: 8px 0;
}

.sidebar-user-icon {
  font-size: 20px;
}

.btn-logout {
  padding: 8px;
  background: #ff6b6b;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s;
  width: 100%;
}

.btn-logout:hover {
  background: #ff5252;
}

.btn-front {
  padding: 8px;
  background: rgba(255, 255, 255, 0.1);
  color: white;
  border-radius: 6px;
  text-decoration: none;
  font-size: 14px;
  text-align: center;
  transition: all 0.3s;
  width: 100%;
  display: block;
}

.btn-front:hover {
  background: rgba(255, 255, 255, 0.2);
}

.admin-main {
  margin-left: 240px;
  flex: 1;
  min-height: 100vh;
}
</style>
